import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SAPPOSTINGKEY_FIELDS: FieldDefinition[] = [
  FieldBuilder.text('name', 'Entity.SapPostingKey.Name')
    .required()
    .build(),
  FieldBuilder.text('sapCode', 'Entity.SapPostingKey.SapCode')
    .required()
    .build(),
  FieldBuilder.text('indicator', 'Entity.SapPostingKey.Indicator')
    .required()
    .build(),
];

export const SAPPOSTINGKEY_CONFIG = {
  entityName: 'SapPostingKey',
  localizationKey: 'Controlling::Entity.SapPostingKey',
  fields: SAPPOSTINGKEY_FIELDS,
  permission: 'ControllingSap.SapPostingKeies',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
